import { ActivityLabelsTable } from "../components/ActivityLabelsTable";

export const ActivityLabelsPage = () => {
  return <ActivityLabelsTable />;
};
